module.exports = __webpack_public_path__ + "img/check.ea1cc2ca.svg";